<template >
    <fragment>
        <span :class="$store.state.editable?'editable':''" v-if = "editing === false" @dblclick="editing=startEdit()">
        {{value}}
        </span>
        <textarea
                ref="textarea"
                :style="computedStyles"
               v-if ="editing === true"
               :value="value"
               v-on:blur= "editing=false; $emit('update')"

               v-on:input="updateValue($event.target.value)"
        />
        <!--
        //@keyup.enter = "editing=false; $emit('update')"
        -->
    </fragment>

</template>


<script>
    export default {
        name: "EditText",
        props: {
            value: {
                type: String
            }
        },
        data(){
            return{
                editing:false,
                height:Number
            }
        },
        mounted(){
            this.resize();
        },
        methods:{
            startEdit(){
              if(this.$store.state.editable){
                  return true;
              }else{
                  return false;
              }
            },
            updateValue: function (value) {
                this.$emit('input', value)
            },
            resize:function(){
                if(this.$refs.textarea){
                    console.log(this.$refs.textarea.scrollHeight);
                    this.$refs.textarea.style.height="0px";
                    this.$refs.textarea.style.height=String(this.$refs.textarea.scrollHeight+4+"px");
                }
            }

        },
        watch:{
          value(){
               this.resize();
          }
        },
        computed:{
            computedStyles () {
                console.log("computedStyles")
                return {
                    height: this.height,
                    //overflow: this.maxHeightScroll ? 'auto' : (!this.isOverflowImportant ? 'hidden' : 'hidden !important')
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .editable{
        &:hover{
            outline: 1px solid pink;
        }
    }
    input,textarea{
        font: inherit;
        display: block;
        background-color: transparent;
        overflow: hidden;
        width: 100%;
        outline: none;
        border: none;
    }
</style>